<template lang="pug">
ul.sidebar-menu
  li.menu-header
  template(v-for="(item, index) in navItems")
    li(
      v-show="getVisible(item.pages)"
      :class="{ 'dropdown' : item.children }"
    )
      router-link.nav-link(:to='item.children ? "#" : item.url' :class="{ 'has-dropdown' : item.children }")
        i(:class="item.icon")
        span {{ item.name }}
          b-badge(v-if="item.badge && item.badge.text" :variant="item.badge.variant") {{ item.badge.text }}
      ul.dropdown-menu(v-if="item.children")
        template(v-for="(child, index1) in item.children")
          li.dropdown-menu-item(
            v-show="getVisible(child.pages)"
            :class="{ 'active' : ($route.fullPath == child.url || $route.fullPath == (child.url + '#') ) }"
          )
            //- router-link.nav-link(:to='child.url')
            //-   i(:class="child.icon")
            //-   span {{ child.name }}
            //-     b-badge(v-if="child.badge && child.badge.text" :variant="child.badge.variant") {{ child.badge.text }}
            template(v-if="child.url != '/site/newwebsite'")
              router-link.nav-link(:to='child.url')
                i(:class="child.icon")
                span {{ child.name }}
                  b-badge(v-if="child.badge && child.badge.text" :variant="child.badge.variant") {{ child.badge.text }}
                  i.fas.fa-circle.text-danger.notif-badge(v-if="child.display_notif" style="margin-left: 6px !important;")
            template(v-else)
              a.nav-link.pointer(@click="redirectWeb(child.url, $route)")
                i(:class="child.icon")
                span {{ child.name }}
                  b-badge(v-if="child.badge && child.badge.text" :variant="child.badge.variant") {{ child.badge.text }}
                  i.fas.fa-circle.text-danger.notif-badge(v-if="child.display_notif" style="margin-left: 6px !important;")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";

export default {
  components: {
  },
  props: {
    navItems: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      subDetail: null,
      feedback: {
        success: false,
        status: errorTags.request.failed
      }
    };
  },
  computed: {
    getCpiDetails() {
      return this.$store.getters.cpiDetails;
    }
  },
  mounted() {
    let cssList = document.querySelectorAll('li.dropdown-menu-item.active');
    for(var i = 0; i < cssList.length; i++) {
      cssList[i].parentElement.style.display = "block";
      cssList[i].parentElement.parentElement.classList.toggle('show');
    }

    let authRole = this.$store.getters.authorityRole ? this.$store.getters.authorityRole : null;

    if (authRole == 'SUB_PRI') {
      this.getSubDetail();
    }

    // Prevent stay display after click child menu in minimized mode
    if ($('body').hasClass('sidebar-mini')) {
      this.$helpers.hideChildMenu();
    }
  },
  methods: {
    // isActive(e) {
    //   console.log(e, e.children);
    //   for(var i = 0; i < e.children.length; i++) {
    //     console.log(this.$route.path == e.children[i].url)
    //   }
    // },
    redirectWeb(url, route) {
      const wLoc = window.location;
      if(wLoc.pathname != url)
        this.$router.push(url)
      else {
        this.$store.dispatch("user/setSelectedNewWebsite", null);
        window.location.href = url
      }
    },
    getSubDetail() {
      let url = config.accountSubDetailUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        login_id: this.$store.getters.loginId
      };

      this.$http.post(url, json).then(
        function(response) {
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.subDetail = response.data.dt.length > 0 ? response.data.dt[0] : null;
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    getVisible(e) {
      // console.log(e)
      if (e) {
        let authRole = this.$store.getters.authorityRole;
        let accountType = this.$store.getters.accountType;
        let result = false;
        let pages = e;
        //pages is list of page in sidebar.vue
        //roles is the list of authority store in db

        if (authRole) {
          if (authRole == 'OWNER_PRI') {
            for (var i = 0; i < pages.length; i++) {
              if(pages[i] == 'cpi') {
                if(this.getCpiDetails == null) {
                  result = false
                  break;
                }
              }
              if(accountType == 2) {
                // console.log(config.operatorAccessOptions)
                if(config.operatorAccessOptions.includes(pages[i])) {
                  return true;
                } else {
                  return false;
                }
              } else {
                if(accountType == 5 || accountType == 4) {
                  if (pages[i] == 'ipwhitelist') {
                    result = false;
                    break;
                  }
                }
                if(accountType == 3 || accountType == 4) {
                  if(pages[i] == 'bodefaultdomain' || pages[i] == 'package' || pages[i] == 'language' || pages[i] == 'themeprovider' || pages[i] == 'themecontent' || 
                      pages[i] == 'themecontentgroup' || pages[i] == 'theme') {
                    result = false;
                    break;
                  }
                }
                if (pages[i] == 'siteinfo' || pages[i] == 'cms' || pages[i] == 'memberlist' || pages[i] == 'memberlabel' || pages[i] == 'socialaccount' ||
                    pages[i] == 'vip' || pages[i] == 'promotion' || pages[i] == 'campaign' || pages[i] == 'rescuefund' || pages[i] == 'turnovertier' || pages[i] == 'operatorsetting') {
                  result = false;
                  break;
                }
              }
              result = true;
            }
          } else {
            if (this.subDetail) {
              let roles = this.subDetail.authority_option;

              roles =  roles && roles.length > 0 ? roles.split(',') : [];
              for (var i = 0; i < pages.length; i++) {
                if(pages[i] == 'cpi') {
                  if(this.getCpiDetails == null) {
                    result = false
                    break;
                  }
                }
                if (pages[i] == 'subaccount' || pages[i] == 'ipwhitelist') {
                  result = false;
                  break;
                }

                if(accountType != 2) {
                  if (pages[i] == 'website') {
                    if (['domainlist','domainavailable','domainapplication','sitelist','newwebsite','operatorinformation'].some(item => roles.includes(item))) {
                      result = true;
                      break;
                    }
                  }

                  //all children menu of account parent menu only can access by operator sub account
                  if (pages[i] == 'account') {
                    result = false;
                    break;
                  }
                  
                  if (pages[i] == 'siteinfo' || pages[i] == 'cms' || pages[i] == 'memberlist' || pages[i] == 'memberlabel' || pages[i] == 'socialaccount' ||
                    pages[i] == 'vip' || pages[i] == 'promotion' || pages[i] == 'campaign' || pages[i] == 'rescuefund' || pages[i] == 'turnovertier' || pages[i] == 'operatorsetting') {
                    result = false;
                    break;
                  }
                } else {
                  if (pages[i] == 'account') {
                    result = false;
                    break;
                  }
                  if(pages[i] == 'siteinfo') {
                    if(this.$helpers.showActionButton('provideroperator') || this.$helpers.showActionButton('minigameop') ) {
                      result = true
                    }
                  }
                  if (pages[i] == 'website') {
                    //if either one of the authority exist then can access website parent menu
                    if (['domainop','domainapplication','siteinfo'].some(item => roles.includes(item))) {
                      result = true;
                      break;
                    }
                  }
                }

                for (var j = 0; j < roles.length; j++) {
                  if (roles[j] == config.accessRoles[pages[i]]) {
                    result = true;
                  }
                }
              }
            }
          }
        }

        return result;
      } else {
        return true;
      }
    },
    scrollHandle(evt) {}
  }
}

</script>

<style lang="scss" scoped>
.notif-badge {
  font-size: 10px;
  margin-right: 0px !important;
}
</style>